import { AccountGroupSelector, DevMenuOption, IconMenu, SceneContainer } from '@sd/components';
import { currentUserState, ROUTES } from '@sd/shared';

import { useRecoilValue } from 'recoil';

export const DeveloperScene = () => {
  const currentUser = useRecoilValue(currentUserState);
  return (
    <SceneContainer heading="Developer Stuff">
      <IconMenu
        items={[
          !!currentUser?.employee && {
            label: 'Admin',
            internalUrl: ROUTES.admin.accountSelect.locationFor({}),
            icon: 'gear'
          },
          { label: 'Add Vehicle', internalUrl: ROUTES.addVehicle.base.locationFor(), icon: 'plus' },
          {
            label: 'Listing Manager',
            internalUrl: ROUTES.listingManager.listingManager.locationFor({}),
            icon: 'checkbox-checked'
          },
          {
            label: 'Listing Manager (Legacy)',
            externalUrl: ROUTES.external.legacySellerDashboard.listingManager.externalUrlFor({}),
            icon: 'checkbox-checked'
          },
          {
            label: 'Account Statistics',
            internalUrl: ROUTES.statistics.accountStatistics.locationFor(),
            icon: 'graph-pie'
          },
          { label: 'Logout', internalUrl: ROUTES.appShell.logout.locationFor(), icon: 'leave' }
        ]}
      />
      <h3>Testing the account selector here</h3>
      <AccountGroupSelector />
      <DevMenuOption label="Developer Stuff">
        <h1>look, I can add custom menus to the developer options just for this page!</h1>
      </DevMenuOption>
    </SceneContainer>
  );
};
